import loading from '@/directive/loading/index.js';
export default {
  name: 'customLoading',
  data() {
    return {
      utilList: [{
        title: '默认效果',
        type: 'loading'
      }, {
        title: 'loading1',
        type: 'pulse'
      }, {
        title: 'loading2',
        type: 'rect'
      }, {
        title: 'loading3',
        type: 'plane'
      }, {
        title: 'loading4',
        type: 'cube'
      }, {
        title: 'loading5',
        type: 'preloader'
      }, {
        title: 'loading6',
        type: 'chase'
      }],
      loading: false,
      full: true
    };
  },
  directives: {
    loading
  },
  methods: {
    //方法loading
    startLoading(item) {
      //可选参数
      //spin: 图标type  后期改为svg
      //text : loading文字
      // textColor:  文字颜色
      // background: 遮罩层背景颜色
      this.$loading.show({
        spin: item.type
      });
      setTimeout(() => {
        this.$loading.hide();
      }, 3000);
    },
    startCustomLoading(index) {
      this.full = index == 1 ? true : false;
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
    }
  }
};